//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import ContainerRowReduxTextField from '../../components/common/ContainerRowReduxTextField'
import ContainerRowReduxCheckboxField from '../ProjectDemeter/common/ContainerRowReduxCheckboxField'
import ContainerRowError from '../../components/common/ContainerRowError'
import ContainerRowReduxAutoCompleteAndOverrideField from '../../components/common/ContainerRowReduxAutoCompleteAndOverrideField'
import ContainerRowReduxReadonlyTextAndOverrideField from '../ProjectDemeter/common/ContainerRowReduxReadonlyTextAndOverrideField'
import * as actions from '../../redux/deimos/actions';
import * as actConfDlgActions from '../../redux/actConfDialog/actions';
import type { ReducerState$Type } from '../../redux/genericFlowTypes';
import type { InvoiceHeaderForm$Props } from './flowTypes'

const refreshTotalAmount=(props:InvoiceHeaderForm$Props)=>{
    const { deimos,isOverrideTotal } = props;
    
    if (!isOverrideTotal){
        let total = (deimos.totalSumOfItemAmount:any);
        if (total){
            total = parseFloat(total)
            const changeFieldValue = (props.changeFieldValue:any)
            changeFieldValue('total',total.toFixed(2))
        }
    }
}

const renderSubmitButton=(props:InvoiceHeaderForm$Props)=>{
    const { pristine,submitting,isInvalidDoc,invalid } = (props:any);
    const submitOpenActionDialog = (props.submitOpenActionDialog:any)
    const deimos:ReducerState$Type = (props.deimos:any)
    
    if (isInvalidDoc && Object.keys(deimos.formError).length == 0){
        return <button type="button" onClick={()=> submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit As Invalid Invoice</button>; 
    }else {
        return (
            <div>
                <button type="button" onClick={()=> submitOpenActionDialog()} 
                className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
            </div>    
        )
    }
}

const autoCompleteDataSourceConfig = {
    text: "vendor_name",
    value: "vendor_name"
}

class InvoiceHeaderForm extends React.Component<InvoiceHeaderForm$Props> {
    
    refreshEditData(){
        if (this.props.isVerifyMode){
            const getTaskData = (this.props.getTaskData:any)
            getTaskData(this.props.jwt,this.props.taskAcceptedInfoId)
        }
    }

    componentWillMount(){
        const { jwt, deimos } = this.props
        if (!deimos.vendorsLoaded){
            const populateVendorsList=(this.props.populateVendorsList:any)
            populateVendorsList(jwt);
        }
    }
    
    componentDidUpdate(){
        refreshTotalAmount(this.props)
    }

    componentDidMount(){
        this.refreshEditData()
    }

    render(){
        const { pristine,submitting,deimos,isInvalidDoc,actConfDialog,jwt,taskAcceptedInfoId,isOverrideVendorName,isOverrideTotal} = (this.props:any);
        const changeFieldValue = (this.props.changeFieldValue:any)
       
        if (deimos.invoiceSubmitted) {
            return <Redirect to='/projectDeimos/submittedForm' />;
        }

        return (
            <div className='container'>
                <ContainerRowReduxCheckboxField field={'isInvalidDoc'} label={'Invalid Document / Missing Pages / Not load'} />
                
                <ContainerRowReduxAutoCompleteAndOverrideField 
                    autoCompleteField={'vendorName'} 
                    autoCompleteDatasourceConfig={autoCompleteDataSourceConfig}
                    label={'Vendor Name'}
                    datas={deimos.vendors}
                    checkboxField={'isOverrideVendorName'}
                    checkboxLabel={'Override this Vendor Name field'}
                    isOverride={isOverrideVendorName}
                    changeFieldValue={changeFieldValue}
                    parentProps={this.props}
                />
                <ContainerRowReduxTextField field={'invNo'} label={'Invoice Number'} />
                <ContainerRowReduxTextField field={'invDate'} label={'Invoice Date'} />
                <ContainerRowReduxTextField field={'poNo'} label={'PO Number'} />
                <ContainerRowReduxTextField field={'serviceAddr'} label={'Service Address'} />
                <ContainerRowReduxReadonlyTextAndOverrideField 
                    textField={'total'} textLabel={'Total'} textType={'number'}
                    checkboxField={'isOverrideTotal'} checkboxLabel={'Override this Total field'}
                    isOverride={isOverrideTotal} notOverrideFunc={refreshTotalAmount} 
                    parentProps={this.props}
                />
                <ContainerRowError errorMsg={deimos.error} />
            
                <div className="row">
                    <div className="col-sm">
                      {renderSubmitButton(this.props)}
                    </div>
                </div>   
            </div>    
        )
    }
}

const mapStateToProps:any = (state, ownProps) => {
    const selector = ownProps.selector

    return {
        isInvalidDoc: selector(state, 'isInvalidDoc'),
        isOverrideVendorName: selector(state, 'isOverrideVendorName'),
        isOverrideTotal: selector(state, 'isOverrideTotal'),
        total: selector(state, 'total')
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
      getTaskData: (jwt:string,taskAcceptedInfoId:number)=>{
        dispatch(actions.getTaskData(ownProps.deimos, jwt, taskAcceptedInfoId))  
      },
      populateVendorsList: (jwt:string)=>{
        dispatch(actions.populateVendorsList(jwt))  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(InvoiceHeaderForm)


// WEBPACK FOOTER //
// ./src/views/ProjectDeimos/InvoiceHeaderForm.js